import { i18n } from '@/plugins/i18n'

export const settlementTarget = {
    PF:        1,
    STARSHOP:  2,
};

export const settlementTargetStr = {
    PF:          i18n.t('settlement_target.pf'),
    STARSHOP:    i18n.t('settlement_target.starshop'),

    get(type) {
        let type_str = null;

        Object.keys(settlementTarget).forEach(item => {
            if(settlementTarget[item] === type) {
                type_str = settlementTargetStr[item];
            }
        });

        return type_str;
    }
};
